class RightMenu {

    constructor() {
        this.menus = [];
        this.addEvent();
    }

    menuHandler(ev){
        ev.preventDefault(ev);

        let todo = {
            OPEN: (menuItem)=>{ menuItem.classList.add('active_btn'); },
            CLOSE: (menuItem)=>{ menuItem.classList.remove('active_btn'); },
        };

        let currentDo = 'OPEN';

        let panel = document.querySelector('[data-menu="panel"]');

        if(panel.classList.contains('open')){
            panel.classList.remove('open');
            currentDo = 'CLOSE';
        } else {
            panel.classList.add('open');
        }

        this.menus.forEach(todo[currentDo]);
    }

    addEvent(){
        let _self = this;
        this.menus = document.querySelectorAll('[data-menu="btn"]');

        this.menus.forEach((menuItem) => {
            menuItem.addEventListener('click', _self.menuHandler.bind(_self));
        });
    }

}